import { render, staticRenderFns } from "./CsSpinInput.vue?vue&type=template&id=65bc6c60&scoped=true&lang=pug&"
import script from "./CsSpinInput.vue?vue&type=script&lang=js&"
export * from "./CsSpinInput.vue?vue&type=script&lang=js&"
import style0 from "./CsSpinInput.vue?vue&type=style&index=0&id=65bc6c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc6c60",
  null
  
)

export default component.exports